import React from 'react';
import Link from 'next/link';
import LaunchIcon from '@mui/icons-material/Launch';

interface Props {
  href: string;
  children: React.ReactNode;
}

export default function LinkBlock({ href, children, ...others }: Props): React.ReactElement {
  if (href.match('http')) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
        {' '}<LaunchIcon fontSize='inherit' style={{ marginBottom: -3 }} />
      </a>
    );
  }

  return (
    <Link href={href} passHref {...others}>
      <a>{children}</a>
    </Link>
  );
}
